import { Skeleton } from '@/ui/skeleton';
import styles from './Sidebar.module.scss';

/** Mimics the 4 accordion section rows: icon + label + chevron */
const SkeletonRow = () => (
  <div className={styles.skeletonRow}>
    <Skeleton className={styles.skeletonIcon} />
    <Skeleton className={styles.skeletonText} />
    <Skeleton className={styles.skeletonChevron} />
  </div>
);

const SidebarSkeleton = () => {
  return (
    <div className={styles.content}>
      <div className={styles.accordion}>
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className={styles.skeletonSection}>
            <SkeletonRow />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SidebarSkeleton;
